import { useAtom } from 'jotai';
import { breadcrumbTitles } from '../store/breadcrumb-atoms';

export const useRouteTitle = match => {
  const [titles, setTitles] = useAtom(breadcrumbTitles);
  const titleId = match?.pathname;
  const title = titles[titleId];

  const setTitle = newTitle => {
    setTitles(prev => ({ ...prev, [titleId]: newTitle }));
  };

  return { title, setTitle };
};
